"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUploadPublisher = void 0;
const R = __importStar(require("ramda"));
const rxjs_1 = require("rxjs");
const fetchUploadPublisher = (byteCount, url, logger) => {
    const bufferSize = 1e6;
    const buffer = new Uint8Array(R.repeat(Number('0'), bufferSize < byteCount ? byteCount : byteCount));
    const abortController = new AbortController();
    const signal = abortController.signal;
    function wait(milliseconds) {
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }
    const stream = new ReadableStream({
        start(controller) {
            return __awaiter(this, void 0, void 0, function* () {
                yield wait(1000);
                controller.enqueue('00000');
                yield wait(1000);
                controller.enqueue('0000000000');
                yield wait(1000);
                controller.enqueue('000000000000000000');
                yield wait(1000);
                controller.enqueue('0000000');
                yield wait(1000);
                controller.enqueue('00000000');
                controller.close();
            });
        },
    }).pipeThrough(new TextEncoderStream());
    return new rxjs_1.Observable(subscriber => {
        try {
            const formData = new FormData();
            formData.set("file-upload", new Blob([buffer]));
            const updateProgress = (len) => {
                logger.info(`uploadPublisher - updateProgress, len = ${len}`);
                subscriber.next(len);
            };
            const responsePromise = fetch(url, {
                method: "POST",
                // body: formData,
                body: stream,
                headers: {
                    'Content-Type': 'text/plain',
                },
                /*
                body: new ReadableStream<Uint8Array>({
                    start: (c) => {
                        console.log(`uploadPublisher - start, buffer.length = ${buffer.length}`);
                        c.enqueue(buffer);
                    },
                    pull: (c) => {
                        console.log(`uploadPublisher - pull, c.desiredSize = ${c.desiredSize}`);
                        updateProgress(c.desiredSize!);
                    },
                }),
                */
                signal: signal,
            });
            responsePromise.then(response => {
                logger.info(`uploadPublisher responsePromise, response = ${response}`);
                if (!response.ok) {
                    logger.info(`uploadPublisher responsePromise, response not ok`);
                    subscriber.error(response);
                    return;
                }
                updateProgress(0);
            }).catch(err => {
                logger.error(`uploadPublisher - error 1`, err);
                subscriber.error(err);
            });
        }
        catch (err) {
            logger.error(`uploadPublisher - error 2`, err);
            subscriber.error(err);
        }
    });
};
exports.fetchUploadPublisher = fetchUploadPublisher;
//# sourceMappingURL=fetchUploadPublisher.js.map